/* eslint-disable import/prefer-default-export */
import { toast } from 'react-toastify';
import Api from '../lib/api/api';
import { ERROR_MESSAGE } from '../lib/constants';

// get OOB Logs data
export const getOobLogs = (token, userId, pagination) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.users.getOobLogs(userId, pagination);
    dispatch({
      type: 'OOB_LOGS_SUCCESS',
      data,
    });
    return data;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'OOB_LOGS_ERROR',
    });
    return false;
  }
};
